import {
  CREATE_TEAM,
  GET_ALL_TEAMS,
  GET_TEAM_INFO,
  SET_TEAM_AVATAR,
  UPDATE_TEAM_INFO,
  SET_TEAM_HEADER_IMAGE,
  CREATE_TEAM_LOADING_STATUS,
  GET_ALL_TEAMS_LOADING_STATUS,
  GET_TEAM_INFO_LOADING_STATUS,
  UPDATE_TEAM_INFO_LOADING_STATUS,
  JOIN_TEAM_REQUEST_LOADING_STATUS,
  GET_TEAM_INVITATION_CODE_LOADING_STATUS,
} from 'constants/actionTypes';

const defaultState = {
  data: [],
  info: {},
};

function teamsReducer(state = defaultState, action) {
  switch (action.type) {
    case GET_ALL_TEAMS:
      return {
        ...state,
        data: action.payload.teams,
      };
    case GET_TEAM_INFO: {
      const team = action.payload;

      return {
        ...state,
        info: {
          ...state.info,
          [team.teamInfo.teamId]: team,
        },
      };
    }
    case CREATE_TEAM:
      return {
        ...state,
        data: [...state.data, action.payload],
      };
    case SET_TEAM_AVATAR: {
      const { teamId } = action.payload;
      const currentTeam = state.info[teamId];

      return {
        ...state,
        data: state.data.map(team => {
          if (Number(teamId) === team.teamId) {
            return {
              ...team,
              personalInfo: {
                ...team.personalInfo,
                avatar: action.payload.avatar,
              },
            };
          }

          return team;
        }),
        info: {
          ...state.info,
          [teamId]: {
            ...currentTeam,
            teamInfo: {
              ...currentTeam.teamInfo,
              personalInfo: {
                ...currentTeam.teamInfo.personalInfo,
                avatar: action.payload.avatar,
              },
            },
          },
        },
      };
    }
    case SET_TEAM_HEADER_IMAGE: {
      const { teamId } = action.payload;
      const currentTeam = state.info[teamId];

      return {
        ...state,
        data: state.data.map(team => {
          if (Number(teamId) === team.teamId) {
            return {
              ...team,
              personalInfo: {
                ...team.personalInfo,
                headerImage: action.payload.avatar,
              },
            };
          }

          return team;
        }),
        info: {
          ...state.info,
          [teamId]: {
            ...currentTeam,
            teamInfo: {
              ...currentTeam.teamInfo,
              personalInfo: {
                ...currentTeam.teamInfo.personalInfo,
                headerImage: action.payload.avatar,
              },
            },
          },
        },
      };
    }
    case UPDATE_TEAM_INFO: {
      const { teamId } = action.payload;
      const currentTeam = state.info[teamId];

      return {
        ...state,
        data: state.data.map(team => (teamId === team.teamId ? action.payload : team)),
        info: {
          ...state.info,
          [teamId]: {
            ...currentTeam,
            teamInfo: {
              ...action.payload,
            },
          },
        },
      };
    }
    case CREATE_TEAM_LOADING_STATUS:
    case GET_ALL_TEAMS_LOADING_STATUS:
    case GET_TEAM_INFO_LOADING_STATUS:
    case UPDATE_TEAM_INFO_LOADING_STATUS:
    case JOIN_TEAM_REQUEST_LOADING_STATUS:
    case GET_TEAM_INVITATION_CODE_LOADING_STATUS: {
      return {
        ...state,
        [action.type]: action.payload,
      };
    }
    default:
      return state;
  }
}

export default teamsReducer;
